export default __webpack_public_path__ + "static/defense-bb7826fc7e5ecb230926aeee4a3aad18.png";